import React from 'react';
function MapMarker({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19 10.364C19 16.09 12 21 12 21s-7-4.91-7-10.636c0-1.953.737-3.826 2.05-5.207C8.363 3.776 10.143 3 12 3c1.857 0 3.637.776 4.95 2.157C18.263 6.537 19 8.41 19 10.364z"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 13a3 3 0 100-6 3 3 0 000 6z" />
    </svg>
  );
}

export default MapMarker;
